import Home from './Home.advertiser-page.vue'

export default {
  Home
}